import { render, staticRenderFns } from "./useful-links.vue?vue&type=template&id=ca2be0e2&scoped=true"
import script from "./useful-links.vue?vue&type=script&lang=js"
export * from "./useful-links.vue?vue&type=script&lang=js"
import style0 from "./useful-links.vue?vue&type=style&index=0&id=ca2be0e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2be0e2",
  null
  
)

export default component.exports